// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__26Il1","Label":"Input_Label__1xtTe","InputElement":"Input_InputElement__2mHGU","Invalid":"Input_Invalid__20ken"};